module.exports = __webpack_public_path__ + "img/c2.8c81a1b2.png";